import BaseRepository from '@/api/repositories/BaseRepository';

export default class CustomerChatMessageRepository extends BaseRepository {
    get endpoint() {
        return 'api/messages';
    }

    getChatMedia(messageId) {
        return this.get(`${messageId}/media`);
    }
}
